"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _reactRouterDom = require("react-router-dom");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

/*
 *  component/button/Link.tsx
 *  Project-Lego
 *
 *  Created by Sola Ogunsakin on 3/18/19.
 *  Copyright © 2019-present ContextLogic Inc. All rights reserved.
 */

/* eslint-disable local-rules/use-link-component */

/* External Libraries */

/* Lego Toolkit */
var propDoc = {
  openInNewTab: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Open the link in a new tab"
  },
  isRouterLink: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "If the button is being used as a link, use this value to " + "indicate if it is an internally handled link. Internal links " + "are handled by react-router and do not refresh the page"
  },
  onClick: {
    required: false,
    defaultValue: "null",
    type: "?() => void",
    description: "Optional callback for button click"
  },
  onMouseOver: {
    required: false,
    defaultValue: "null",
    type: "?() => void",
    description: "Optional callback for button is hovered"
  },
  download: {
    required: false,
    defaultValue: "false",
    type: "?boolean",
    description: "Indicates that is a link to a download file"
  },
  fadeOnHover: {
    required: false,
    defaultValue: "true",
    type: "?boolean",
    description: "Indicates the link should fade when it is hovered by the mouse"
  }
};
var demoRender = "\n<Link\n  href=\"www.google.com\"\n  openInNewTab\n>\n  View details\n</Link>\n";

var Link = function Link(props) {
  var styles = useStylesheet(props);
  var href = props.href,
      style = props.style,
      className = props.className,
      isRouterLink = props.isRouterLink,
      openInNewTab = props.openInNewTab,
      onClick = props.onClick,
      fadeOnHover = props.fadeOnHover,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["href", "style", "className", "isRouterLink", "openInNewTab", "onClick", "fadeOnHover"]);
  var rootClassName = (0, _styling.css)(styles.root, style, className);
  var navigator = (0, _providers.useLegoNavigator)();

  var onClickHandler = function onClickHandler(e) {
    if (href) {
      navigator.navigate(href, {
        openInNewTab: openInNewTab
      });
      e.preventDefault();
    }

    if (onClick) {
      onClick(e);
    }
  };

  if (onClick) {
    return /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({
      className: rootClassName,
      href: href || undefined,
      onClick: onClickHandler,
      target: openInNewTab ? "_blank" : undefined,
      rel: "noopener noreferrer"
    }, otherProps), otherProps.children);
  }

  if (isRouterLink) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, (0, _extends2["default"])({
      className: rootClassName
    }, otherProps, {
      to: href || ""
    }), otherProps.children);
  } // Linter false positive: `noreferrer` is being applied

  /* eslint-disable react/jsx-no-target-blank */


  return /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({
    className: rootClassName,
    rel: openInNewTab ? "noopener noreferrer" : undefined,
    target: openInNewTab ? "_blank" : undefined,
    href: href || undefined,
    onClick: onClickHandler
  }, otherProps), otherProps.children);
};

Link.propDoc = propDoc;
Link.demoProps = {
  href: "http://www.wish.com"
};
Link.demoRender = demoRender;

var _default = (0, _mobxReact.observer)(Link);

exports["default"] = _default;

var useStylesheet = function useStylesheet(_ref) {
  var _ref$fadeOnHover = _ref.fadeOnHover,
      fadeOnHover = _ref$fadeOnHover === void 0 ? true : _ref$fadeOnHover;

  var _useTheming = (0, _providers.useTheming)(),
      primary = _useTheming.theme.primary,
      fonts = _useTheming.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        opacity: 1,
        color: primary,
        transition: "opacity 0.3s linear",
        cursor: "pointer",
        pointerEvents: "auto",
        fontFamily: fonts.semibold,
        textDecoration: "none",
        ":link": {
          textDecoration: "none"
        },
        ":visited": {
          textDecoration: "none"
        },
        ":hover": {
          textDecoration: "none",
          opacity: fadeOnHover ? 0.6 : 1
        },
        ":active": {
          textDecoration: "none"
        }
      }
    });
  }, [fadeOnHover, primary, fonts.semibold]);
};